export default "__VITE_ASSET__8133d922__"